import * as forms from "@client/forms";
import * as typography from "@client/shared/typography";
import {Layout} from "@client/site/Layout";
import {reverse, server} from "@reactivated";
import React from "react";

export const Template = (props: server.manager.templates.ConfirmManager) => {
    const profile_form = forms.useForm(props.profile_form);
    const password_form = forms.useForm(props.password_form);
    return (
        <Layout narrow title="Confirm manager">
            <form
                noValidate
                method="POST"
                action=""
                className="flex flex-col space-y-[15px]"
                onSubmit={
                    props.is_registering === true
                        ? forms.guard([profile_form, password_form])
                        : forms.guard([profile_form])
                }
            >
                <forms.CSRFToken />
                <forms.FormErrors form={profile_form} />
                <typography.Header>Confirm manager</typography.Header>

                <typography.P>Please fill out the details below.</typography.P>
                <typography.P>
                    Upon submission, you will confirm{" "}
                    <strong>{props.manager.email}</strong> as your manager.
                    <br />
                    They will have full access to your journal, reports and all other
                    metrics.
                </typography.P>
                <forms.Fields form={profile_form} fields={["email", "name"]} />
                <div className="m-[-5px] flex flex-wrap items-end *:m-[5px]">
                    <forms.Fields
                        form={profile_form}
                        fields={["date_of_birth", "gender", "zip_code"]}
                    />
                </div>
                {props.is_registering === true && (
                    <>
                        <typography.Header>Pick a password</typography.Header>
                        <forms.Form form={password_form} />
                    </>
                )}

                <typography.P>
                    By clicking confirm, you agree to our{" "}
                    <typography.A href={reverse("terms_of_service")}>
                        terms of service
                    </typography.A>
                    .
                </typography.P>
                <typography.Button submit>Confirm</typography.Button>
            </form>
        </Layout>
    );
};
